import React, {  useEffect} from 'react';
//import Button from '@mui/material/Button';
 
import { Button } from '@mui/material';
import { Link,useNavigate } from "react-router-dom";
import AxiosFetchData from '../pages/AxiosFetchData';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
  
import MainPrint from '../pages/MainPrint.js';
import RetentionPrint from '../pages/RetentionPrint.js';
import {Modal, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Helper from '../pages/Helper.js';
export default function PrintPreviewV3({children, open,setopen,id=null, id2=null }) {
    const [content, setContent] = React.useState({__html: ''});
    const Navigate = useNavigate();
    var result = "";
    var nbsp = "&nbsp;"
    var totalInvoice = 0;
    var mainPrint;
  useEffect(() => {
     const urlParams =  window.location.pathname.split('/')[1];
    
     mainPrint = new MainPrint();
     if(urlParams == 'EditInvoiceV3' || urlParams == 'EditInvoiceRetention'){
        if(urlParams == 'EditInvoiceRetention'){
          mainPrint = new RetentionPrint(id)
        }
        handleEditPrintInvoice(id, id2)
        return;
      }
     
      handleAddPrintInvoice(id)
     
  }, [open]);
  
  
async function handleEditPrintInvoice(id, id2){
    try{
     
      var response = await AxiosFetchData.get(`GetInvoiceV3/${id}/${id2}`).refreshToken(Navigate);
   
      if(response)
      {
        PrintExisted(id, response.data)
      }
    }catch(error){
       // console.log(error)
          //setmessage(error.message);
    }
      
  }
 

  async function handleAddPrintInvoice(id){
    try{
      var response = await AxiosFetchData.get(`GetCustomer/${id}`).refreshToken(Navigate);
     
      if(response)
      {
      //  alert(response.data[0].paymentermid)
         // setpaymentterm(response.data[0].paymentermid)
          Print(id, response.data)
      }
    }catch(error){
          //setmessage(error.message);
    }
      
  }

  function Print(id, cust){
    try{
        var data = {
            data : JSON.parse(children)
          }
          
          result ='';
          GetTreeView(data.data.treeview);
        
          setContent({__html: mainPrint.printInvoice(`${result}`, cust, data.data.invoice, data.data.retensi, data.data.note)});
    }catch(error){
        console.log(error)
    }
    
  }

  function PrintExisted(id, resp){
    try{
        var data = {
            data : JSON.parse(children)
          }
          
          result ='';
          GetTreeView(data.data.treeview);
        
          setContent({__html: mainPrint.printInvoiceExisted(`${result}`, resp.customer, data.data.invoice, data.data.retensi, data.data.note)});
    }catch(error){
        console.log(error)
    }
    
  }
  
function GetTreeView(data)
{ 
    var no =1;
    for(let i = 0; i <  data.length; i++){
        
            result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                        <td>&nbsp;</td>`

                        if(data[i].part_no){
                            result +=  `<td>${no++}.</td>`
                        }else{
                            result += `<td>&nbsp;</td>`
                        }
                       
              result += `<td>${data[i].part_no ?  data[i].part_no : ""}</td>
                        <td>${data[i].descriptions ? data[i].descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''}</td>
                        <td>${data[i].newqty ? data[i].newqty : ""}</td>
                        <td>${data[i].unit_name ? data[i].unit_name : ""}</td>
                        <td>${data[i].price ?  Helper.formatAsCurrency(data[i].price) : ""}</td>
                        
                        <td>${(data[i].newqty && data[i].price) ?  Helper.formatAsCurrency(data[i].newqty * data[i].price) : ""}</td>
                </tr>`
            if(data[i].newqty && data[i].price){
                totalInvoice += data[i].newqty * data[i].price
            }

            if(data[i].subChild){
              recursive(data[i].subChild);
            }
            
         
            nbsp ="";
       
    }
  
}

//var nbsp = "&nbsp;"
function recursive(data)
{
   
    if( data.length > 0){
        
        nbsp += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
        for(let i = 0; i < data.length; i++){
        
                result +=`<tr style="background-color: ${i % 2 === 0 ? '#f1f1f1' : '#ffffff'}; font-family:arial; font-size:11px;" key=${i}>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>${nbsp}${data[i].part_no ? data[i].part_no : ""}</td>
                            <td>${nbsp}- ${data[i].descriptions}</td>
                            <td>${data[i].newqty ? data[i].newqty : ""}</td>
                            <td>${data[i].unit_name ?  data[i].unit_name : ""}</td>
                            <td>${data[i].price ? Helper.formatAsCurrency(data[i].price) : "-"}</td>
                            
                            <td>${(data[i].newqty && data[i].price) ? Helper.formatAsCurrency((data[i].newqty * data[i].price)) : ""}</td>
                        </tr>`

                        if(data[i].newqty && data[i].price){
                            totalInvoice += data[i].newqty * data[i].price
                        }
                   
                        if(data[i].subChild){
                          recursive(data[i].subChild);
                        }
         }
        
    }
   
}

  return (
     
      <Modal
        open={open}
        onClose={() => setopen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="satu"
      >
        <Box className='modals' >
        <div id="testId" className="test"> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div id="modalcontent" dangerouslySetInnerHTML={content}>
              
            </div>
           
          </Typography>
          <Typography id="modal-modal-description">
          
            <button
              onClick={() => setopen(false)}
              className='close-button'
            >
              Close
            </button>
          </Typography>
          </div>
        </Box>
        </Modal>
     
       
    
  );
}